import axios from 'axios'
import {BASE_URL, API_VERSION, GETREGIONS} from '../endpoints'

export const GET_ALL_REGIONS = 'GET_ALL_REGIONS'
export const ADD_REGION = 'ADD_REGION'
export const EDIT_REGION = 'EDIT_REGION'
export const DELETE_REGION = 'DELETE_REGION'

export const getAllRegions = () => (dispatch) => {
    const accessToken = window.localStorage.getItem('accessToken')
    let options = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ` + accessToken,
            'Accept': 'application/json',
        },
    };
    return axios.get(BASE_URL + API_VERSION + GETREGIONS + '?size=300&admin=true', options)
        .then((response) => {
            dispatch({ type: GET_ALL_REGIONS, payload: response.data})
            return Promise.resolve(response.data)
        })
        .catch((error) => {
            return Promise.reject(error.response.data.error)
        })
}


export const addRegion = (payload) => (dispatch) => {
    let apiHeader = {
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        }
    }
    return axios.post(BASE_URL + API_VERSION + GETREGIONS, payload, apiHeader)
        .then(response => {
            dispatch({ type: ADD_REGION, payload: response.data });
            return Promise.resolve()
        })
        .catch((error) => {
            return Promise.reject(error.response.data.error)
        })
}

export const deleteRegion = (id) => (dispatch) => {
    const accessToken = window.localStorage.getItem('accessToken')
    let apiHeader = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ` + accessToken,
            'Accept': 'application/json',
        },
    };
    return axios.delete(BASE_URL + API_VERSION + GETREGIONS + '/' + id, apiHeader)
        .then(response => {
            dispatch({ type: DELETE_REGION, payload: id });
            return Promise.resolve(response.data)
        })
        .catch((error) => {
            return Promise.reject(error.response.data.error)
        })
}

export const editRegion = (id, payload) => (dispatch) => {
    const accessToken = window.localStorage.getItem('accessToken')
    let apiHeader = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ` + accessToken,
            'Accept': 'application/json',
        },
    };
    return axios.put(BASE_URL + API_VERSION + GETREGIONS + '/' + id, payload, apiHeader)
        .then(response => {
            dispatch({ type: EDIT_REGION, payload: response.data });
            return Promise.resolve()
        })
        .catch((error) => {
            return Promise.reject(error.response.data.error)
        })
}